import React from "react";
import NavBar from "../Components/HeaderAndFooter/NavBar";
import Footer from "../Components/HeaderAndFooter/Footer";

const Layout = ({ children }) => {
  return (
    <div>
      <NavBar />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
